.#{$namespace}-message {
	position: fixed;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 320px;
	max-width: 80%;
	padding: 10px 16px;
	border-radius: 4px;
	border: 1px solid $border-color;
	background: $white-color;
	box-shadow: 0 4px 12px alpha-color($black-color, 8%);
	box-sizing: border-box;
	overflow: hidden;
	// top 管堆叠往上缩；transform / opacity 管进出场。漏掉 transform 时 leave-to 的位移会瞬移，看起来卡一下
	transition:
		top 0.3s ease,
		opacity 0.3s ease,
		transform 0.3s ease;

	&__icon {
		font-size: 18px;
		flex-shrink: 0;
	}

	&__content {
		margin: 0;
		flex: 1;
		font-size: $font-size;
		line-height: 1.5;
		color: $text-secondary-color;
	}

	&__badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 18px;
		height: 18px;
		margin-right: 6px;
		padding: 0 4px;
		border-radius: 9px;
		background: color-token(danger);
		color: $white-color;
		font-size: 12px;
	}

	&__close {
		padding: 0;
		border: none;
		background: transparent;
		cursor: pointer;
		color: $text-placeholder-color;
		font-size: 14px;

		&:hover {
			color: $text-primary-color;
		}
	}

	&.is-success {
		border-color: color-token(success, light-8);
		background: color-token(success, light-9);

		.#{$namespace}-message__icon {
			color: color-token(success);
		}
	}

	&.is-warning {
		border-color: color-token(warning, light-8);
		background: color-token(warning, light-9);

		.#{$namespace}-message__icon {
			color: color-token(warning);
		}
	}

	&.is-info {
		border-color: color-token(info, light-8);
		background: color-token(info, light-9);

		.#{$namespace}-message__icon {
			color: color-token(info);
		}
	}

	&.is-error {
		border-color: color-token(danger, light-8);
		background: color-token(danger, light-9);

		.#{$namespace}-message__icon {
			color: color-token(danger);
		}
	}
}

// 进出场跟堆叠共用 0.3s，关一张时下面的 top 才能跟离场一起走，不会先停再跳
.#{$namespace}-message-fade-enter-active,
.#{$namespace}-message-fade-leave-active {
	transition:
		top 0.3s ease,
		opacity 0.3s ease,
		transform 0.3s ease;
}

.#{$namespace}-message-fade-enter-from,
.#{$namespace}-message-fade-leave-to {
	opacity: 0;
	// -100% 按自身高度往上收；只挪 16px 时条还在，下面往上缩会对着一张半透明条挤
	transform: translate(-50%, -100%);
}
